import { render, staticRenderFns } from "./TablaContactos.vue?vue&type=template&id=13c1bd92"
import script from "./TablaContactos.vue?vue&type=script&lang=js"
export * from "./TablaContactos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports